import { render, staticRenderFns } from "./PackagesComponent.vue?vue&type=template&id=fef9e1be&"
import script from "./PackagesComponent.vue?vue&type=script&lang=js&"
export * from "./PackagesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports